var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaQs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FAQs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000398746082 0.767 52.0692602 0.767 52.0692602 52.9999 0.000398746082 52.9999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-approval-flow---intro-Hover-state",
    transform: "translate(-682.000000, -995.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQs",
    transform: "translate(682.000000, 994.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.233200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0345304,50.9109 C12.8061292,50.9109 2.08285016,40.1529 2.08285016,26.8839 C2.08285016,13.6139 12.8061292,2.8559 26.0345304,2.8559 C39.2629317,2.8559 49.9862107,13.6139 49.9862107,26.8839 C49.9862107,40.1529 39.2629317,50.9109 26.0345304,50.9109 M26.0345304,0.7669 C11.6557467,0.7669 0.000398746082,12.4599 0.000398746082,26.8839 C0.000398746082,41.3069 11.6557467,52.9999 26.0345304,52.9999 C40.4133141,52.9999 52.0696589,41.3069 52.0696589,26.8839 C52.0696589,12.4599 40.4133141,0.7669 26.0345304,0.7669",
    id: "Fill-1",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.8333185,35.3526 C26.7027292,35.2966 26.5541962,35.2586 26.4236069,35.2586 C26.2930176,35.2586 26.1245473,35.2966 26.0148922,35.3526 C25.7527166,35.4676 25.5672997,35.6736 25.4526602,35.9216 C25.3390176,36.1866 25.3390176,36.4906 25.4696069,36.7166 C25.5842464,36.9986 25.7736508,37.2046 26.0148922,37.3026 C26.1454815,37.3586 26.2930176,37.3966 26.4236069,37.3966 C26.5541962,37.3966 26.7236633,37.3586 26.8333185,37.3026 C27.3736194,37.0766 27.6178514,36.4516 27.3736194,35.8996 C27.280911,35.6516 27.073563,35.4636 26.8333185,35.3526",
    id: "Fill-4",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4828207,18.066 C21.570269,18.066 20.2623818,21.816 20.2623818,23.767 C20.2623818,24.336 20.7299116,24.81 21.2911467,24.81 C21.7985511,24.733 22.3219053,24.357 22.338852,23.788 C22.338852,23.429 22.5073223,20.17 26.5037549,20.17 C27.1955793,20.17 28.9341122,20.286 29.9060558,21.496 C30.6905887,22.462 30.8381248,23.861 30.2808771,24.81 C29.8891091,25.512 29.1414602,26.098 28.3948082,26.684 L28.3778614,26.701 C28.1535668,26.872 27.8714539,27.081 27.6302125,27.287 C26.2465636,28.459 25.4440871,30.28 25.4440871,32.153 C25.4440871,32.722 25.9126138,33.197 26.4748458,33.197 C27.0360809,33.197 27.5036107,32.722 27.5036107,32.153 C27.508595,30.922 28.0319492,29.729 28.9690025,28.933 C29.1923003,28.745 29.4155981,28.574 29.660827,28.386 L29.6777737,28.369 C30.5171342,27.706 31.4880809,26.927 32.0702502,25.888 C33.062131,24.165 32.8169022,21.816 31.4920683,20.187 C30.407479,18.844 28.5762376,18.066 26.4828207,18.066",
    id: "Fill-6",
    fill: "#FEFEFE"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQs);
export default __webpack_public_path__ + "static/media/FAQs.603e02c4.svg";
export { ForwardRef as ReactComponent };